export const IMAGES = {
  path: "https://images.unsplash.com/photo-1759474854358-62f08c1b555e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800&fit=crop",
  bench:
    "https://images.unsplash.com/photo-1560261198-c93f25fdcd5d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800&fit=crop",
  couple:
    "https://images.unsplash.com/photo-1758686253677-d3af6c15186e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&fit=crop",
  derrick: "/images/derrick-speaking.jpg",
};

export const REQUEST_TYPES = [
  "Staff workshop / inservice",
  "Keynote / conference address",
  "Caregiver group workshop",
  "Faith community gathering",
  "Book signing / author conversation",
  "Interview / podcast",
  "Something else",
];

export const LOCATION_FORMATS = ["In-person", "Virtual", "Flexible / undecided"];

// Publication status for each title is deliberately NOT shown — it is awaiting
// the owner's confirmation. Do not add status badges until it is confirmed.
export const INQUIRY_CATEGORIES = [
  "General Question",
  "Copyright & Permissions",
  "Organizational Licensing",
  "Facilitator Training & Certification",
  "Books, Workbooks & Resources",
  "Speaking, Workshops & Partnerships",
  "Other",
];

export const BOOKS = [
  {
    id: "from-diagnosis-to-goodbye",
    title: "From Diagnosis to Goodbye",
    subtitle:
      "Restoring the Patient's Voice Through Every Stage of the Journey",
    author: "Chaplain Derrick Hall",
    cover: "/covers/main-book.jpg",
    amazon: "https://www.amazon.com/dp/0980212723",
    tag: "The foundational book",
    forWhom:
      "For patients who want to stay in charge of their own story, for families learning to listen instead of shield, and for the chaplains, nurses, and doctors who sit beside them both.",
    description: [
      "From Diagnosis to Goodbye was written from the bedside — out of the conversations that happen when treatment decisions pile up, when the vocabulary turns clinical, and when a family's love starts speaking louder than the patient's own wishes.",
      "It follows the whole arc of the journey: the day of diagnosis, the seasons of treatment, the turn toward hospice, and the goodbye itself. At every stage it asks the same question — does the person living this still get to say what they want?",
    ],
  },
  {
    id: "hospice-workbook",
    title: "Hospice Workbook",
    subtitle:
      "A Guided Companion for Preparation, Presence, and Family Conversation",
    author: "Chaplain Derrick Hall",
    cover: "/covers/hospice-workbook.jpg",
    amazon: "https://www.amazon.com/dp/0980212731",
    tag: "Companion workbook",
    description: [
      "A guided companion for the season of caring — preparation, presence, and the family conversations that matter most, with space to write and room to think.",
    ],
  },
  {
    id: "first-year-after-goodbye",
    title: "The First Year After Goodbye",
    subtitle:
      "Understanding Grief, the Firsts, the Holidays, and Learning to Live Forward",
    author: "Chaplain Derrick Hall",
    cover: "/covers/first-year.jpg",
    amazon: "https://www.amazon.com/dp/B0HG66LG3V",
    amazonKindle: true,
    tag: "The bereavement book",
    description: [
      "For the firsts, the holidays, and the long ordinary days — understanding grief and learning to live forward, one season at a time.",
    ],
  },
  {
    id: "bereavement-workbook",
    title: "Bereavement Workbook",
    subtitle: "A Guided Companion for Reflection, Healing, and Life After Loss",
    author: "Chaplain Derrick Hall",
    cover: "/covers/bereavement-workbook.jpg",
    amazon: "https://www.amazon.com/dp/098021274X",
    tag: "Bereavement resource",
    description: [
      "A guided companion for reflection, healing, and life after loss — gentle structure for carrying what has been lost and living what remains.",
    ],
  },
];

export const FREE_RESOURCES = [
  {
    id: "questions-after-terminal-diagnosis",
    section: "serious-illness",
    title: "Questions to Ask After a Terminal Diagnosis",
    subtitle: "A Practical Conversation Guide for Patients and Families",
    description: [
      "Receiving a terminal diagnosis can leave patients and families feeling overwhelmed and uncertain about what to ask.",
      "This free downloadable guide provides thoughtful questions to help families communicate with healthcare professionals, understand hospice services, explore emotional and spiritual concerns, and honor the wishes of the person receiving care.",
    ],
    file: "/files/FDTG_Questions_After_Terminal_Diagnosis_Free_Guide.pdf",
  },
  {
    id: "creating-a-legacy",
    section: "serious-illness",
    title: "Creating a Legacy",
    subtitle: "Letters, Videos, Stories, and the Gift of Remembering",
    description: [
      "Every life has a story worth preserving. This free companion guide by Chaplain Derrick Hall offers practical and meaningful ways to preserve family memories, record personal stories, write letters, share wisdom, and create lasting keepsakes for loved ones.",
      "Whether facing serious illness or simply wanting to preserve treasured memories, this guide encourages families to focus on connection, love, and the moments that matter.",
    ],
    file: "/files/FDTG_Creating_a_Legacy_Free_Guide.pdf",
  },
  {
    id: "difficult-conversations",
    section: "serious-illness",
    title: "How to Have Difficult Conversations During Serious Illness",
    subtitle: "Gentle Conversation Starters for Patients and Families",
    description: [
      "Serious illness can make even simple conversations feel difficult. Families may avoid important subjects because they fear causing distress or saying the wrong thing.",
      "This free guide by Chaplain Derrick Hall offers gentle conversation starters, practical listening techniques, and thoughtful questions to help patients and families communicate with greater honesty, compassion, and understanding.",
      "Inspired by Chapter 5 of From Diagnosis to Goodbye, the guide reminds readers that meaningful conversations begin with listening and respecting the patient's voice.",
    ],
    file: "/files/FDTG_Difficult_Conversations_Free_Guide.pdf",
  },
  {
    id: "when-grief-begins",
    section: "grief-bereavement",
    title: "When Grief Begins: Finding Your Way Through Loss",
    subtitle: "Compassionate Guidance for Patients, Families, and Caregivers",
    description: [
      "Grief does not always begin when someone dies. For many patients and families, it begins with a serious diagnosis, changes in independence, or the realization that life may never be quite the same.",
      "Whether you are preparing for the loss of someone you love or learning to live after their death, grief can bring many emotions, including sadness, uncertainty, anger, guilt, loneliness, and even moments of relief.",
      "This free guide by Chaplain Derrick Hall offers compassionate encouragement, practical coping strategies, and gentle reflection questions to help individuals and families understand anticipatory grief, navigate bereavement, and find meaningful ways to remember and honor their loved ones.",
      "Grief has no single timetable, and healing does not mean forgetting. You do not have to navigate the journey alone.",
    ],
    // PDF supplied and verified 2026-02 — buttons active.
    file: "/files/FDTG_When_Grief_Begins_Free_Guide.pdf",
  },
  {
    id: "the-grief-we-carry",
    section: "grief-bereavement",
    title: "The Grief We Carry: Caring for Those Who Care",
    subtitle: "Understanding Grief, Loss, and Emotional Well-Being in Healthcare",
    description: [
      "Healthcare professionals often walk alongside patients and families during some of life's most difficult moments. While their work involves providing comfort, compassion, and professional care, the emotional impact of repeated loss can sometimes go unrecognized.",
      "Nurses, hospice professionals, chaplains, social workers, caregivers, and other healthcare team members may experience grief following the death of patients they have cared for, particularly when meaningful relationships have developed over time.",
      "This free guide by Chaplain Derrick Hall explores professional grief, cumulative loss, emotional fatigue, and the importance of acknowledging the human experience behind caregiving.",
      "Through practical reflection questions, healthy coping strategies, and encouragement toward peer support and self-care, the guide reminds healthcare professionals that recognizing their own grief is not a sign of weakness.",
      "Those who care for others deserve compassion and support, too.",
    ],
    // PDF supplied and verified 2026-02 — buttons active.
    file: "/files/FDTG_The_Grief_We_Carry_Free_Guide.pdf",
  },
  {
    id: "self-care-checklist",
    section: "grief-bereavement",
    title: "A Self-Care Checklist for Healthcare Workers & Caregivers",
    description: [
      "Caring for others begins with remembering that your well-being matters, too. This free, two-page printable checklist offers practical self-care reminders, reflection questions, healthy boundary suggestions, and emotional support guidance for healthcare professionals, hospice workers, and family caregivers.",
    ],
    // PDF supplied and verified 2026-02 — buttons active.
    file: "/files/FDTG_Self_Care_Checklist_Healthcare_Workers_and_Caregivers.pdf",
  },
];
